(function () {
  function bindCartForm(form) {
    if (form.dataset.ajaxCartBound === '1') {
      return;
    }

    form.dataset.ajaxCartBound = '1';

    form.addEventListener('submit', function (event) {
      event.preventDefault();

      var submitBtn = form.querySelector('[type="submit"]');

      if (submitBtn && submitBtn.disabled) {
        return;
      }

      var addingText = form.dataset.addingText || 'Ekleniyor...';
      var normalText = submitBtn ? submitBtn.textContent : '';

      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.setAttribute('aria-busy', 'true');
        submitBtn.textContent = addingText;
      }

      var actionUrl = form.action;

      if (actionUrl.indexOf('.js') === -1) {
        actionUrl = actionUrl.split('?')[0] + '.js';
      }

      fetch(actionUrl, {
        method: 'POST',
        body: new FormData(form),
        headers: { Accept: 'application/json' },
      })
        .then(function (response) {
          return response.json().then(function (json) {
            if (!response.ok) {
              throw new Error(json.description || json.message || 'Add to cart failed');
            }

            return json;
          });
        })
        .then(function (addedLine) {
          if (form.closest('[data-quick-view-root]') && typeof window.closeQuickView === 'function') {
            window.closeQuickView();
          }

          return fetch('/cart.js', {
            headers: { Accept: 'application/json' },
          })
            .then(function (cartResponse) {
              return cartResponse.json();
            })
            .then(function (cart) {
              document.dispatchEvent(
                new CustomEvent('joker:cart-add-success', {
                  bubbles: true,
                  detail: {
                    line: addedLine,
                    form: form,
                    currency: cart.currency || '',
                  },
                })
              );

              if (typeof window.showCartAddedPopover === 'function') {
                window.showCartAddedPopover(cart, addedLine);
              }

              document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
            })
            .catch(function () {
              document.dispatchEvent(
                new CustomEvent('joker:cart-add-success', {
                  bubbles: true,
                  detail: {
                    line: addedLine,
                    form: form,
                    currency: '',
                  },
                })
              );

              if (typeof window.showCartAddedPopover === 'function') {
                window.showCartAddedPopover({ item_count: addedLine.quantity || 1 }, addedLine);
              }
            });
        })
        .catch(function () {
          form.submit();
        })
        .finally(function () {
          if (!submitBtn) {
            return;
          }

          submitBtn.disabled = false;
          submitBtn.removeAttribute('aria-busy');
          submitBtn.textContent = normalText;
        });
    });
  }

  function bindAllAjaxCartForms(root) {
    var scope = root && root.querySelectorAll ? root : document;
    scope.querySelectorAll('form[data-ajax-cart]').forEach(bindCartForm);
  }

  window.bindAjaxCartForms = bindAllAjaxCartForms;

  bindAllAjaxCartForms(document);

  document.addEventListener('shopify:section:load', function (event) {
    if (!event.target) {
      return;
    }

    bindAllAjaxCartForms(event.target);
  });
})();
